var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('span',{staticClass:"divider",style:({ borderTop: ("solid 1px " + (_vm.$themeTokens.fineLine)) })})])}
var staticRenderFns = []

export { render, staticRenderFns }